import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";

export const useGetLoggedUser = (token) => {
    const data = useQuery(
        ["Logged_User"],
        async () => {
            const { data } = await axios.get(
                "method/custom_api.api.get_logged_user"
            );
            return data?.message[0];
        },
        {
            retry: 0,
            enabled: !!token,
        }
    );
    return data;
};

const getUserDefailts = (key) => {
    const params = {
        key,
    };
    return axios.get(`method/custom_api.api.get_user_defaults`, { params });
};

export const useGetUserDefaults = (key) => {
    return useQuery(
        ["userDefaults", key],
        async () => {
            const { data } = await getUserDefailts(key);
            return data;
        },
        {
            enabled: true,
        }
    );
};

const updateuserDefaults = async (key, value) => {
    const params = {
        key,
        value,
    };
    try {
        const response = await axios.post(
            `method/custom_api.api.set_user_defaults`,
            params
        );
        return response;
    } catch (error) {
        console.error(`Error while updating ${key} ( ${value} ) : ${error}`);
    }
};

export const useUpdateuserDefaults = () => {
    return useMutation(async ({ key, value }) => {
        const data = await updateuserDefaults(key, value);
        return data;
    });
};

export const useLogout = () => {
    return useMutation(async () => {
        const data = await axios.post("method/logout");
        return data;
    });
};
